import PropTypes from 'prop-types'
import { productPropTypes } from 'Types'
import React from 'react'
import {
  skin,
  withGAEvent,
  path,
  useProcessAffiliateLink,
  getClosestCategoryLabel,
  getClosestCategoryObj,
} from 'Utils'
import skins from './skins'
import config, { gaSelectors } from 'Config'
import { Link, Icon } from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'

const buyButtonLabel = config.buyButton.label
const buyButtonLowStockLabel = config.buyButton.lowStockLabel
const useBuyButtonIcon = config.buyButton.useBuyButtonIcon

const BuyButton = ({
  categories = [],
  id,
  store: { name: storeName, network },
  brand,
  affiliateUrl,
  prices: {
    currency: { symbol, code },
    raw: rawPrice
  },
  className,
  flags: { isDiscounted, isStocked },
  shouldRender = true
}) => {
  const categoryPath =
    categories.length > 0 ? categories.map(c => c.name).join(' > ') : ''
  let amplitude = {}
  amplitude.eventProps = {}
  amplitude.eventProps['Product UUID'] = id
  amplitude.eventProps['Category Path'] = categoryPath
  amplitude.eventProps['store'] = storeName || brand
  amplitude.eventType = config.amplitude.types.clicks.buyButton

  const GAlabel = [
    id,
    `store=${storeName}`,
    `isStocked=${isStocked}`,
    `isDiscounted=${isDiscounted}`,
    `price=${symbol}${rawPrice}`
  ]

  const additionalProps = {
    id,
    value: rawPrice,
    currency: code,
    store: storeName || brand,
    buyButtonStore: storeName || brand,
    isStocked,
    isDiscounted,
    ...getClosestCategoryObj(categories),
  }

  if (categories.length > 1) {
    GAlabel.concat(getClosestCategoryLabel(categories))
  }

  const Button = withGAEvent(Link, {
    amplitude,
    category: gaSelectors.getBuyBtnSettings.category,
    action: gaSelectors.getBuyBtnSettings.action,
    label: GAlabel.join(' - '),
    additionalProps,
    className,
  })

  affiliateUrl = useProcessAffiliateLink(affiliateUrl, network)

  const outgoingLink = config.interStitialEnabled
    ? path(p.OUTGOING, {
        storeName: storeName,
        to: encodeURIComponent(affiliateUrl)
      })
    : affiliateUrl

  return shouldRender ? (
    <Button
      to={outgoingLink}
      className={className}
      target="_blank"
      rel="nofollow"
      itemProp="url"
      refs={id}
    >
      {useBuyButtonIcon && (
        <Icon className="buy-button__icon" name="buy-button" />
      )}
      {isStocked ? buyButtonLabel : buyButtonLowStockLabel}
    </Button>
  ) : null
}

BuyButton.propTypes = {
  ...productPropTypes,
  className: PropTypes.string,
  id: PropTypes.any,
  shouldRender: PropTypes.bool
}

export default skin(BuyButton, skins)
